import { PATH_NAME } from 'configs/pathName';

export const openAiPage = () => window.open(PATH_NAME.AI, '_blank');
